/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { useState, useRef, useCallback } from "react";

import {
  Popover,
  PopoverAnchor,
  PopoverContent,
} from "@bigbinary/neeto-atoms/primitives";

import ProductSwitcherMenu from "./Menu";
import MenuItemButton from "./MenuButton";

const Dropdown = () => {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }, []);

  return (
    <Popover {...{ open }} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <MenuItemButton
          onClick={() => setOpen(prev => !prev)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </PopoverAnchor>
      <PopoverContent
        align="start"
        className="z-[99999] w-[calc(100vw-25rem)] max-w-none overflow-y-auto rounded-xl p-0"
        collisionPadding={16}
        side="right"
        sideOffset={8}
        style={{ maxHeight: "var(--radix-popover-content-available-height)" }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ProductSwitcherMenu />
      </PopoverContent>
    </Popover>
  );
};

export default Dropdown;
